import {OrderConstants, SET_ORDER} from "../../../constants/MonitorConstants";
import {GeneralAction} from "../../../@types/actions";

export const SetOrderAction = (data: OrderConstants): GeneralAction<OrderConstants> => ({
    type: SET_ORDER,
    payload: data
});
